import React, {Component} from "react";
import {
    withScriptjs,
    withGoogleMap,
    GoogleMap,
    Marker,
    MarkerWithLabel,
    InfoWindow
} from "react-google-maps";
import LoadingIndicator from '../../utils/LoadingIndicator';
import {Row, Col, Progress, Card, CardHeader, CardTitle, FormGroup, Label, Form, Input, CardBody, Modal, ModalHeader, ModalBody, ModalFooter, Button, ButtonDropdown, Table, Badge,  Pagination, PaginationItem, PaginationLink, DropdownMenu,DropdownToggle, ButtonGroup,Dropdown,DropdownItem, FormText, InputGroup} from 'reactstrap';

const { InfoBox } = require("react-google-maps/lib/components/addons/InfoBox");
const { compose, withProps, withStateHandlers } = require("recompose");
const mapStyle = require("./style.json");

let iconPath = 'M27.648-41.399q0-3.816-2.7-6.516t-6.516-2.7-6.516 2.7-2.7 6.516 2.7 6.516 6.516 2.7 6.516-2.7 2.7-6.516zm9.216 0q0 3.924-1.188 6.444l-13.104 27.864q-.576 1.188-1.71 1.872t-2.43.684-2.43-.684-1.674-1.872l-13.14-27.864q-1.188-2.52-1.188-6.444 0-7.632 5.4-13.032t13.032-5.4 13.032 5.4 5.4 13.032z';
const mapOptions = {
    styles: mapStyle,
    mapTypeId: 'roadmap',
    mapTypeControl: false,
    zoomControl: true,
    streetViewControl: false,
    draggableCursor: 'default',
    draggingCursor: 'move'
};

const Mapoverview = compose(
    withStateHandlers(() => ({
        isOpen: [false,false,false],
    }), {
        onToggleOpen: ({ isOpen }) => (index) => (
            {
                isOpen: !isOpen,
                clickedMarker: index

            }
        )
    }),
    withScriptjs,
    withGoogleMap
)(props =>
    <GoogleMap
        defaultZoom={5}
        defaultCenter={{ lat: 40.275244, lng: -95.471742 }}
        defaultOptions={props.defaultOptions}
    >
        {props.markers.map((marker, index)=> {
            let fillColor = marker.online ? "#1f8e46" : "#f86c6b";
            return (
                <Marker
                    key={index}
                    position={marker.points}
                    icon={{
                        path: iconPath,
                        fillColor: fillColor,
                        fillOpacity: .8,
                        scale: .50,
                        strokeWeight: 0,
                    }}
                    onClick={() => props.onToggleOpen(index)} >
                    {(props.clickedMarker === index) && <InfoWindow onCloseClick={() => {props.onToggleOpen(undefined)}}>
                        <div>
                            <i className={`fa fa-${marker.online === 1 ? marker.rssi === undefined ? 'question-circle-o' : 'signal' : 'times-circle-o'} text-${marker.online === 1? (marker.rssi < -85 ? "danger" : marker.rssi < -75 ? "warning" : marker.rssi < -65 ? "success" : "success" ) : "secondary"}`}> </i> <strong>{marker.siteName}</strong>
                            <br />
                            {marker.alarm === 1?<div className="small text-danger">In Alarm</div>:<div className="small text-muted">No Alarms</div>}
                            <br />
                            <Button block color="light" className="btn-sm" onClick={() => props.goToSite(`/site/overview/device_${marker.device}/${marker.siteName.replace(/\s/g, "+")}`)}>View Site</Button>
                        </div>
                    </InfoWindow>}
                </Marker>
            )
        })}
    </GoogleMap>
);

class Map extends Component {
    constructor(props) {
        super(props);
        this.state = {
            loading: true
        }

    }
    componentDidMount() {
        this.setState({
            loading: false
        })

    }

    render() {
        let siteData = this.props.sites;
        if (this.state.loading || siteData === undefined) {
            return <LoadingIndicator />;
        }
        const mapMarkers = () => {
            let site = [];
            for (let s = 0; s < siteData.length; s++) {
                site.push({
                    siteName: siteData[s]['siteName'],
                    online: siteData[s]['online'],
                    rssi: siteData[s]['rssi'],
                    alarm: siteData[s]['alarm'],
                    device: siteData[s]['deviceName'],
                    points: {
                        lat: siteData[s]['gpsLat'],
                        lng: siteData[s]['gpsLong']
                    }
                })
            }
            return site;
        };

        return (
            <Mapoverview
                googleMapURL="https://maps.googleapis.com/maps/api/js?key=AIzaSyCuTHa_YCHBy5hzO7WXw487_POPepP9ak4&v=3.exp&libraries=geometry,drawing,places"
                loadingElement={<div style={{ height: `100%` }} />}
                containerElement={<div style={{ height: `600px` }} />}
                mapElement={<div style={{ height: `100%` }} />}
                defaultOptions={mapOptions}
                markers={mapMarkers()}
                goToSite={(url) => this.props.goToSite(url)}
            />
        )
    }
}

export default Map;



// WEBPACK FOOTER //
// ./src/views/Dashboard/Map.js